import server from '../request';
import encryptServer from '../request/encryptRequest';

// 工单处理
export const todoWork = data => server.post('/xiaozi-xmb/wireless/saas/Workbench/backlog', data);

// 工单评价
export const evaluation = data => server.post('/xiaozi-xmb/wireless/saas/Workbench/evaluation', data);

// 运营统计
export const operationalStatistics = data =>
  server.post('/xiaozi-xmb/wireless/saas/Workbench/operationalStatistics', data);

// 工单统计
export const workOrderStatistics = data => server.post('/xiaozi-xmb/wireless/saas/Workbench/workOrderStatistics', data);

// 协同办公列表
export const workbenchHandle = data => server.post('/yiwei-workflow/wireless/task/queryPageList', data);

// 采购统计
export const statistics = data => encryptServer.post('/xiaozi-xms/wireless/saas/statistics/queryInfo', data);
